import { useLayoutEffect } from 'react';
import { useTranslation } from 'src/arb-wrapper';

export const useDocumentTitle = (title?: string) => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    document.title = `${t('leela_title')}${title ? `: ${title}` : ''}`;
  });
};
